import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { useText, useGetAvatarUrl, useImage } from 'common/hooks';
import { AvatarWrapper, AvatarImage, ActiveSinceText } from './elements';
import dayjs from 'dayjs';

function handleOnFileSelected(event, signalPassed) {
  const image = new Image();
  const { files } = event.target;

  image.addEventListener('load', () => {
    signalPassed({
      file: files[0],
      width: image.width,
      height: image.height,
    });
  });

  image.src = window.URL.createObjectURL(files[0]);
  window.URL.revokeObjectURL(files[0]);
}

const deps = {
  profile: state.appContainer.profiles[state.appContainer.user.uid],
  isSavingProfile: state.account.isSavingProfile,
  avatarFileSelected: sequences`account.avatarFileSelected`,
  avatarFileDeleted: sequences`account.avatarFileDeleted`,
};

export function ImageAndJoinedTime({
  profile,
  isSavingProfile,
  avatarFileSelected,
  avatarFileDeleted,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const getAvatarUrl = useGetAvatarUrl();
  const [url, isLoading] = useImage(getAvatarUrl(profile).large);

  return (
    <>
      <AvatarWrapper>
        <AvatarImage
          isLoading={isLoading || !profile || isSavingProfile}
          profile={profile}
          onAddAvatar={event => {
            handleOnFileSelected(event, avatarFileSelected);
          }}
          onDeleteAvatar={() => {
            avatarFileDeleted({
              avatarImagePathsToRemove: profile.avatarImage,
            });
          }}
          image={url}
        />
      </AvatarWrapper>
      <ActiveSinceText>
        {profile && 'joinedDatetime' in profile
          ? t('account.settings.profile.general_info.active_since', {
              date: dayjs(profile.joinedDatetime).format('LL'),
            })
          : '-'}
      </ActiveSinceText>
    </>
  );
}

export default connect(deps, ImageAndJoinedTime);
